import { AppRouteProps } from "@harea/component";
import React from "react";

const PrimesBenefitsContainer = React.lazy(
    () => import("./views/primes/container/PrimesBenefitsContainer")
);

const IndemnitiesBenefitsContainer = React.lazy(
    () => import("./views/indemnities/container/IndemnitiesBenefitsContainer")
);

const PaybacksBenefitsContainer = React.lazy(
    () => import("./views/paybacks/container/PaybacksBenefitsContainer")
);

export const OrganizationBenefitsRoutes: Array<AppRouteProps> = [
    {
        path: "primes",
        title: "std_prime",
        roles: ["ADMIN", "SUPER_ADMIN", "DIRECTOR_HR", "SETTINGS"],
        element: <PrimesBenefitsContainer />,
    },
    {
        path: "indemnities",
        title: "std_indemnities",
        roles: ["ADMIN", "SUPER_ADMIN", "DIRECTOR_HR", "SETTINGS"],
        element: <IndemnitiesBenefitsContainer />,
    },
    {
        path: "paybacks",
        title: "std_payback",
        roles: ["ADMIN", "SUPER_ADMIN", "DIRECTOR_HR", "SETTINGS"],
        element: <PaybacksBenefitsContainer />,
    },
];
